var _style, _g, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g2, _g3, _g4, _defs2, _path11, _path12, _path13, _g5, _g6, _g7, _defs3, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#16164F;}\n\t.st2{clip-path:url(#SVGID_00000039852201530731670010000008292320724459966600_);enable-background:new    ;}\n\t.st3{fill:#101038;}\n\t.st4{fill:#10103A;}\n\t.st5{fill:#11113C;}\n\t.st6{fill:#11113D;}\n\t.st7{fill:#12123F;}\n\t.st8{fill:#121241;}\n\t.st9{fill:#131343;}\n\t.st10{fill:#131345;}\n\t.st11{fill:#141447;}\n\t.st12{fill:#151549;}\n\t.st13{fill:#0E0E30;}\n\t.st14{fill:#329188;}\n\t.st15{fill:#205C56;}\n\t.st16{fill:#00D3C3;}\n\t.st17{fill:#00ADA0;}\n\t.st18{clip-path:url(#SVGID_00000001637534896001894900000010439666035357336476_);enable-background:new    ;}\n\t.st19{fill:#2E2B74;}\n\t.st20{fill:#2C2A70;}\n\t.st21{fill:#2B286C;}\n\t.st22{fill:#4440AB;}\n\t.st23{fill:#3E3A9D;}\n\t.st24{fill:#2E2A75;}\n\t.st25{clip-path:url(#SVGID_00000054961726297715817330000015712598452715567281_);enable-background:new    ;}\n\t.st26{fill:#2A276B;}\n\t.st27{fill:#292668;}\n\t.st28{fill:#282566;}\n\t.st29{fill:#272463;}\n\t.st30{fill:#252360;}\n\t.st31{fill:#24225D;}\n\t.st32{fill:#23215A;}\n\t.st33{fill:#222057;}\n\t.st34{fill:#211F55;}\n\t.st35{fill:#201E52;}\n\t.st36{fill:#1F1D4F;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M553.82,376.77c119.91,0,217.11,48.6,217.11,108.56c0,41.01-40.11,75.06-111.85,94.95l-105.26-94.95V376.77 z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    className: "st0",
    d: "M770.92,485.33v86.6c0,41.01-40.11,75.06-111.85,94.95v-86.6 C730.81,560.39,770.92,526.34,770.92,485.33z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120545155077241343650000011072611141370742681_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000120545155077241343650000011072611141370742681_)",
      enableBackground: "new"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M770.92,485.33v86.6c0,0.48-0.01,0.96-0.02,1.44v-86.6C770.92,486.29,770.92,485.81,770.92,485.33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M770.91,486.77v86.6c-0.08,3.48-0.45,6.92-1.11,10.29v-86.6C770.45,493.69,770.83,490.25,770.91,486.77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M769.8,497.06v86.6c-0.61,3.16-1.48,6.27-2.59,9.33v-86.6C768.32,503.33,769.18,500.22,769.8,497.06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M767.21,506.39v86.6c-1.08,2.98-2.4,5.91-3.94,8.78v-86.6C764.81,512.3,766.12,509.37,767.21,506.39"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M763.26,515.18v86.6c-1.55,2.89-3.34,5.73-5.35,8.51v-86.6C759.93,520.91,761.71,518.07,763.26,515.18"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M757.91,523.69v86.6c-2.1,2.91-4.46,5.75-7.05,8.53v-86.6C753.46,529.44,755.81,526.59,757.91,523.69"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M750.86,532.22v86.6c-2.86,3.06-6.01,6.03-9.45,8.92v-86.6C744.85,538.25,748,535.27,750.86,532.22"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M741.41,541.14v86.6c-4.21,3.53-8.84,6.94-13.9,10.2v-86.6C732.57,548.07,737.21,544.67,741.41,541.14"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M727.51,551.34v86.6c-8.46,5.46-18.1,10.54-28.86,15.19v-86.6C709.41,561.88,719.05,556.8,727.51,551.34"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M698.65,566.53v86.6c-11.85,5.12-25.07,9.72-39.58,13.74v-86.6C673.58,576.25,686.8,571.65,698.65,566.53 "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "659.07,580.27 659.07,666.88 553.82,571.93 553.82,485.33  "
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M553.82,376.3v108.56l-133.67-85.55C459.93,383.78,503.33,376.3,553.82,376.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "553.82,484.86 553.82,571.46 420.15,485.92 420.15,399.32  "
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M420.15,399.82l133.67,85.54L343.15,459.1C355.36,434.61,380.37,415.36,420.15,399.82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "553.82,485.36 553.82,571.97 343.15,545.7 343.15,459.1  "
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000041993062312173766730000017601877831019500966_",
    className: "st0",
    d: "M336.47,573.23l0-86.6 c0,39.37,42.69,75.82,115.41,95.16v86.6C379.16,649.05,336.47,612.59,336.47,573.23z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018229504740713650050000006809536097018191744_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041993062312173766730000017601877831019500966_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000018229504740713650050000006809536097018191744_)",
      enableBackground: "new"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M451.88,581.78v86.6c-4.41-1.17-8.7-2.41-12.88-3.7v-86.6C443.18,579.38,447.48,580.61,451.88,581.78"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M439,578.09v86.6c-8.11-2.51-15.8-5.24-23.04-8.18v-86.6C423.2,572.84,430.89,575.58,439,578.09"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M415.95,569.9v86.6c-50.65-20.53-79.48-50.92-79.48-83.28v-86.6 C336.47,518.98,365.31,549.37,415.95,569.9"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M343.15,459.67l210.66,26.26l-101.93,95.85C362.74,558.08,318.73,508.65,343.15,459.67z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "553.82,485.93 553.82,572.54 451.88,668.39 451.88,581.78  "
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M553.82,485.6l105.26,94.95c-33.65,9.32-69.38,13.99-105.15,13.99c-34.58,0-69.2-4.36-102.04-13.09 L553.82,485.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000011725129482703347170000005758803938389218973_",
    className: "st0",
    d: "M659.07,580.55v86.6 c-33.65,9.32-69.38,13.99-105.15,13.99c-34.58,0-69.2-4.36-102.04-13.09v-86.6c32.84,8.73,67.46,13.09,102.04,13.09 C589.69,594.55,625.42,589.88,659.07,580.55z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109009475303780189440000003180728048937699203_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011725129482703347170000005758803938389218973_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000109009475303780189440000003180728048937699203_)",
      enableBackground: "new"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M659.07,580.55v86.6c-1.73,0.48-3.46,0.94-5.19,1.4v-86.6C655.61,581.5,657.34,581.03,659.07,580.55"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M653.88,581.95v86.6c-13.56,3.54-27.44,6.34-41.5,8.39v-86.6C626.44,588.29,640.32,585.49,653.88,581.95"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M612.38,590.34v86.6c-8.23,1.2-16.52,2.14-24.86,2.83v-86.6C595.86,592.48,604.15,591.54,612.38,590.34"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M587.52,593.17v86.6c-6.8,0.56-13.62,0.95-20.45,1.17v-86.6C573.91,594.12,580.73,593.73,587.52,593.17"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M567.07,594.33v86.6c-4.38,0.14-8.77,0.21-13.15,0.21c-1.76,0-3.52-0.01-5.28-0.03v-86.6 c1.76,0.02,3.52,0.03,5.28,0.03C558.31,594.55,562.69,594.48,567.07,594.33"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M548.64,594.51v86.6c-5.81-0.07-11.62-0.27-17.41-0.59v-86.6C537.03,594.24,542.83,594.44,548.64,594.51"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M531.23,593.92v86.6c-5.7-0.32-11.4-0.75-17.08-1.3v-86.6C519.83,593.17,525.52,593.6,531.23,593.92"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M514.15,592.61v86.6c-5.76-0.56-11.5-1.25-17.21-2.05v-86.6C502.66,591.37,508.4,592.05,514.15,592.61"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M496.95,590.56v86.6c-6-0.85-11.97-1.83-17.9-2.95v-86.6C484.97,588.73,490.94,589.71,496.95,590.56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M479.04,587.61v86.6c-6.48-1.22-12.92-2.61-19.3-4.16v-86.6C466.12,585,472.56,586.39,479.04,587.61"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M459.74,583.45v86.6c-2.63-0.64-5.25-1.3-7.86-2v-86.6C454.49,582.15,457.11,582.81,459.74,583.45"
  }))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.dcaa0a03ecc15b65029da2bfdddcf62f.svg";
export { ForwardRef as ReactComponent };